import { createGlobalStyle } from 'styled-components';

import { DSTokenMap, FONT_FAMILY, HEADER_STYLES } from '@rover/kibble/styles';

const globalStyles = `
  html {
    box-sizing: border-box;
    -webkit-text-size-adjust: 100%;
  }

  *, *:before, *:after {
    box-sizing: inherit;
  }

  body {
    display: flex;
    flex-direction: column;
    height: 100%;
    font-family: ${FONT_FAMILY};
    font-size: 14px;
    line-height: 1.3;
    margin: 0;
    color: ${DSTokenMap.TEXT_COLOR_PRIMARY};
    -webkit-font-smoothing: antialiased;
  }

  #app {
    -ms-overflow-y: hidden; // helps IE11 flexbox issues, particularly on the search page
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  }

  ${HEADER_STYLES}

  main {
    flex-grow: 1; // take up space between header and footer even if no content
  }

  a {
    color: ${DSTokenMap.INTERACTIVE_TEXT_COLOR_LINK_PRIMARY};
    text-decoration: none;
    &:hover, &:focus {
      color: ${DSTokenMap.INTERACTIVE_TEXT_COLOR_LINK_PRIMARY_PRESSED};
      text-decoration: underline;
    }
  }

  input,
  button,
  select,
  textarea {
    font-family: inherit;
    font-size: inherit;
    line-height: inherit;
  }

  img[width="1"][height="1"], img[width="0"][height="0"] {
    position: absolute; /* Targets the tracking pixel and removes the element from displaying in the document flow */
    display: none;
`;
export default globalStyles;
export const GlobalStyles = createGlobalStyle`
  ${globalStyles}
`;
